import { render, staticRenderFns } from "./DriverDetail.vue?vue&type=template&id=8499dd00&scoped=true&"
import script from "./DriverDetail.vue?vue&type=script&lang=js&"
export * from "./DriverDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8499dd00",
  null
  
)

export default component.exports